export const COMPUTED_VALUE = "<computed>";
